const ARTICLE_PRODUCT_CARD_PREFIX = "ArticleProductCard";

export const ARTICLE_PRODUCT_CARD_CLASSES = {
  grid: `${ARTICLE_PRODUCT_CARD_PREFIX}-grid`,
  productCardBox: `${ARTICLE_PRODUCT_CARD_PREFIX}-productCardBox`,
};
